function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useSingleton } from '@bydesign-ui/hooks';
import React from 'react';
import { Carousel } from '../lib/Carousel';
import { CarouselContext } from '../context/carousel';
export function RcCarousel(props) {
  var children = props.children,
      options = _objectWithoutProperties(props, ["children"]);

  var carousel = useSingleton(function () {
    return new Carousel(options);
  });
  carousel.updateCarouselOptions(options);
  return React.createElement(CarouselContext.Provider, {
    value: carousel
  }, children);
}